import schemapack from "schemapack";
import { NAME_SERVER } from "../../Utils/NAME_HOST";
import ErrorComponent from "../../components/UI/Error/ErrorComponent";
import Sound_play from "../../Utils/sound_play";
import { sound_winGAME, succses_bet } from "../../Utils/sounds";
var msgpack = require("msgpack-lite");


let SCREEN_WIDTH = document.documentElement.clientWidth;
let SCREEN_HEIGHT = document.documentElement.clientHeight;

let GAME_WIDTH = 600;
let GAME_HEIGHT = 300;
const GRID_SIZE = 100;
const SNAKE_SPEED = 7;
const FAST_SPEED = 17;
var baseWidth = 800; // базовая ширина
var baseHeight = 600; // базовая высота
const SPACE_BETWEEN = 200;
const CIRCLE_RADIUS = 80;
const STRING_BALANCE = "";
class Styles {
    constructor(color, width, fast, socket) {
        this.resStyle = {}

        if (color === "red") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#f32424",
                borderColor: "#a90000",
                normalSpeed: "rgba(243 , 36 , 36,0.9)",
                fastSpeed: "rgba(0,21,255,0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(255,255,255,0.9)",
                color: "rgba(255,255,255,0.9)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#F65A5A" : "white",
                borderColor: "red",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }
        else if (color === "blue") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#0418fa",
                borderColor: "#0A3375",
                normalSpeed: "rgba(28, 84, 176, 0.9)",
                fastSpeed: "rgba(255 , 0 , 0 , 0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(28, 84, 176,0.1)",
                borderColor: "rgba(28, 84, 176,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#1C54B0" : "white",
                borderColor: "#0A3375",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }
        else if (color === "white" || color === "russia") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#ececec",
                borderColor: "#808080",
                normalSpeed: "rgba(236 ,236 , 236,0.9)",
                fastSpeed: "rgba(253,4,102,0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(169, 117, 4,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#FFB400" : "white",
                borderColor: "#A97504",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }

        else if (color === "gold") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#FFB400",
                borderColor: "#A97504",
                normalSpeed: "rgba(180,130,13,0.9)",
                fastSpeed: "rgba(0,21,255,0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(169, 117, 4,0.1)",
                borderColor: "rgba(169, 117, 4,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#FFB400" : "white",
                borderColor: "#A97504",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }
        else if (color === "twitch") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#9146FF",
                borderColor: "#231146",
                normalSpeed: "rgba(145, 70, 255, 0.9)",
                fastSpeed: "rgba(255 , 0 , 0 , 0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(28, 84, 176,0.1)",
                borderColor: "rgba(28, 84, 176,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#1C54B0" : "white",
                borderColor: "#0A3375",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }
        else if (color === "green") {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#8AFF14",
                borderColor: "#468F00",
                normalSpeed: "rgba(70 , 143 , 0)",
                fastSpeed: "rgba(255 , 0 , 0 , 0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(70,143,0,0.1)",
                borderColor: "rgba(70,143,0,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#8AFF14" : "white",
                borderColor: "#468F00",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
        }
        else {
            let styles = {}
            styles["black"] = {
                color: "black",
                borderColor: "black",
                width: width / 4
            };
            styles["snack"] = {
                color: "#8AFF14",
                borderColor: "#468F00",
                normalSpeed: "rgba(70 , 143 , 0)",
                fastSpeed: "rgba(255 , 0 , 0 , 0.6)",
                width: width
            };
            styles["shadow"] = {
                borderColor: "rgba(70,143,0,0.1)",
                borderColor: "rgba(70,143,0,0.1)",
                color: "rgba(0,0,0,0.1)",
                width: width * 1.25
            };
            styles["eye"] = {
                color: fast ? "#8AFF14" : "white",
                borderColor: "#468F00",
                width: fast ? width : width / 2
            };
            this.resStyle = styles
            // socket.send(this.game.pack({event:"ErrorClient", data:{
            //         color ,width,fast,
            //         message:"В рисовке нет стиля"
            //     }}))

        }

    }
}


class BG {
    constructor(game) {
        this.game = game;
        this.ctx = this.game.ctx;
        this.isDrawing = true;
        this.bgCanvas = document.createElement("canvas");
        this.bgCanvas.classList.add("canvas"); // Замените "your-class-name" на нужное имя класса

        this.bgCtx = this.bgCanvas.getContext("2d");
        this.bgCanvas.width = GAME_WIDTH;
        this.bgCanvas.height = GAME_HEIGHT;
        this.preloadCircles();
        // this.bgX = 0; // Начальное положение фона по оси X
        // this.bgY = 0; // Начальное положение фона по оси Y
    }

    getScreenCoordinates(x, y) {
        const snakeX = this.game.playerSnake.x - 5;
        const snakeY = this.game.playerSnake.y - 5;
        const offsetX = snakeX % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);
        const offsetY = snakeY % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);

        const screenX = x - (CIRCLE_RADIUS + offsetX);
        const screenY = y - (CIRCLE_RADIUS + offsetY);

        return { x: screenX, y: screenY };
    }
    preloadCircles() {
        const snakeX = Math.abs(this.game.playerSnake.x);
        const snakeY = Math.abs(this.game.playerSnake.y);

        const offsetX = snakeX % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);
        const offsetY = snakeY % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);

        for (let y = GAME_HEIGHT - (CIRCLE_RADIUS + offsetY); y >= 0; y -= CIRCLE_RADIUS * 2 + SPACE_BETWEEN) {
            for (let x = GAME_WIDTH - (CIRCLE_RADIUS + offsetX); x >= 0; x -= CIRCLE_RADIUS * 2 + SPACE_BETWEEN) {
                this.drawCircle({ x, y }, this.bgCtx);
            }
        }
    }

    drawCircle(centerPos, ctx) {

        const circleX = centerPos.x;
        const circleY = centerPos.y;
        const circleRadius = CIRCLE_RADIUS / 3;
        const isCircleVisible =
            circleX + circleRadius >= this.game.screen.left &&
            circleX - circleRadius <= this.game.screen.right &&
            circleY + circleRadius >= this.game.screen.top &&
            circleY - circleRadius <= this.game.screen.bottom;
        // if (isCircleVisible) {
        const gradient = ctx.createRadialGradient(
            centerPos.x,
            centerPos.y,
            0,
            centerPos.x,
            centerPos.y,
            CIRCLE_RADIUS
        );
        gradient.addColorStop(0, "#11172E");
        gradient.addColorStop(1, "#0d151e");

        ctx.beginPath();
        ctx.arc(centerPos.x, centerPos.y, CIRCLE_RADIUS, 0, 2 * Math.PI);
        ctx.closePath();

        ctx.fillStyle = gradient;
        ctx.fill();

        ctx.strokeStyle = "#0d151e";
        ctx.stroke();



    }


    draw() {
        // if (!this.isDrawing) {
        //
        //     // alert("Game over")
        //     return;
        // }

        const snakeX = this.game.playerSnake.x - 5;

        const snakeY = this.game.playerSnake.y - 5;
        const offsetX = snakeX % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);
        const offsetY = snakeY % (CIRCLE_RADIUS * 2 + SPACE_BETWEEN);






        // if ((Math.abs(this.game.playerSnake.y) >= (GAME_HEIGHT - (SCREEN_HEIGHT / 2)) && this.game.playerSnake.y < 0) || (!this.game.id_follow_bot)) {
        //     this.ctx.strokeStyle = "red"; // Установка цвета линии на красный
        //     this.ctx.lineWidth = 4; // Установка ширины линии

        //     // Расчет X-координат начала и конца линии в зависимости от позиции змейки
        //     // Рисование линии конца карты
        //     this.ctx.beginPath();
        //     // this.ctx.moveTo(startX - this.game.snake.x, startY - this.game.snake.y);
        //     // this.ctx.lineTo(startX - this.game.snake.x, GAME_HEIGHT - this.game.snake.y);
        //     // this.ctx.moveTo(startX - this.countDistance * koef - koefD, startY - 200 - this.countDistance * koef-koefD);
        //     // this.ctx.lineTo(startX - this.countDistance * koef- koefD, GAME_HEIGHT - this.countDistance * koef-koefD);
        //     // //console.log(this.lastPosX)
        //     const begining = GAME_HEIGHT - (SCREEN_HEIGHT / 2);

        //     let BeginY = (Math.abs(this.game.playerSnake.y) - begining) - 22//заменить 1080 на SCREEN_WIDTH

        //     this.ctx.moveTo(0, BeginY)
        //     this.ctx.lineTo(SCREEN_WIDTH, BeginY);

        //     this.ctx.stroke();
        //     this.ctx.closePath();
        //     this.ctx.lineWidth = 1;
        // }
        // //вверх

        // if ((Math.abs(this.game.playerSnake.y) >= (GAME_HEIGHT - (SCREEN_HEIGHT / 2)) && this.game.playerSnake.y > 0) || (!this.game.id_follow_bot)) {
        //     // //console.log("YES");
        //     this.ctx.strokeStyle = "red"; // Установка цвета линии на красный
        //     this.ctx.lineWidth = 4; // Установка ширины линии

        //     // Расчет X-координат начала и конца линии в зависимости от позиции змейки
        //     // Рисование линии конца карты
        //     this.ctx.beginPath();
        //     // this.ctx.moveTo(startX - this.game.snake.x, startY - this.game.snake.y);
        //     // this.ctx.lineTo(startX - this.game.snake.x, GAME_HEIGHT - this.game.snake.y);
        //     // this.ctx.moveTo(startX - this.countDistance * koef - koefD, startY - 200 - this.countDistance * koef-koefD);
        //     // this.ctx.lineTo(startX - this.countDistance * koef- koefD, GAME_HEIGHT - this.countDistance * koef-koefD);
        //     // console.log(this.lastPosX)
        //     const begining = GAME_HEIGHT - (SCREEN_HEIGHT / 2);
        //     const BeginY = GAME_HEIGHT - (this.game.playerSnake.y - begining) - (GAME_HEIGHT - SCREEN_HEIGHT) + 22//заменить 1080 на SCREEN_WIDTH

        //     this.ctx.moveTo(0, BeginY)
        //     this.ctx.lineTo(SCREEN_WIDTH, BeginY);

        //     this.ctx.stroke();
        //     this.ctx.closePath();
        //     this.ctx.lineWidth = 1;


        // }
        // //левая сторона
        // if ((Math.abs(this.game.playerSnake.x) >= (GAME_WIDTH - (SCREEN_WIDTH / 2)) && this.game.playerSnake.x < 0) || (!this.game.id_follow_bot)) {
        //     this.ctx.strokeStyle = "red"; // Установка цвета линии на красный
        //     this.ctx.lineWidth = 4; // Установка ширины линии
        //     this.ctx.beginPath();
        //     const begining = GAME_WIDTH - (SCREEN_WIDTH / 2);
        //     const BeginX = (Math.abs(this.game.playerSnake.x) - begining) - 22;
        //     // this.ctx.moveTo(BeginX,  GAME_HEIGHT)
        //     // this.ctx.lineTo(BeginX , 0)
        //     this.ctx.moveTo(BeginX, SCREEN_HEIGHT)
        //     this.ctx.lineTo(BeginX, 0)
        //     this.ctx.stroke();
        //     this.ctx.closePath();
        //     this.ctx.lineWidth = 1;


        // }
        // //правая сторона
        // if ((Math.abs(this.game.playerSnake.x) >= (GAME_WIDTH - (SCREEN_WIDTH / 2)) && this.game.playerSnake.x >= 0) || (!this.game.id_follow_bot)) {
        //     // console.log(this.game.snake.x)
        //     // console.log("YES");
        //     this.ctx.strokeStyle = "red"; // Установка цвета линии на красный
        //     this.ctx.lineWidth = 4; // Установка ширины линии

        //     // Расчет X-координат начала и конца линии в зависимости от позиции змейки
        //     // Рисование линии конца карты
        //     this.ctx.beginPath();
        //     // this.ctx.moveTo(startX - this.game.snake.x, startY - this.game.snake.y);
        //     // this.ctx.lineTo(startX - this.game.snake.x, GAME_HEIGHT - this.game.snake.y);
        //     // this.ctx.moveTo(startX - this.countDistance * koef - koefD, startY - 200 - this.countDistance * koef-koefD);
        //     // this.ctx.lineTo(startX - this.countDistance * koef- koefD, GAME_HEIGHT - this.countDistance * koef-koefD);
        //     // console.log(this.lastPosX)
        //     const begining = GAME_WIDTH - (SCREEN_WIDTH / 2);

        //     const BeginX = GAME_WIDTH - (this.game.playerSnake.x - begining) - (GAME_WIDTH - SCREEN_WIDTH) + 22//заменить 1080 на SCREEN_HEIGHT
        //     this.ctx.moveTo(BeginX, SCREEN_HEIGHT)
        //     this.ctx.lineTo(BeginX, 0);

        //     this.ctx.stroke();
        //     this.ctx.closePath();
        //     this.ctx.lineWidth = 1;
        // }
        // let begining = GAME_HEIGHT - (SCREEN_HEIGHT / 2);
        // let BeginY = (Math.abs(this.game.playerSnake.y) - begining) - 22;//заменить 1080 на SCREEN_WIDTH
        // let BeginX = (Math.abs(this.game.playerSnake.x) - (GAME_WIDTH - (SCREEN_WIDTH / 2))) - 22;
        // this.ctx.fillStyle = "#11172E";
        // if ((Math.abs(this.game.playerSnake.y) >= (GAME_HEIGHT - (SCREEN_HEIGHT / 2)) && this.game.playerSnake.y < 0) || (!this.game.id_follow_bot)) {

        //     this.ctx.rect(0, 0, SCREEN_WIDTH, BeginY)
        // }
        // if ((Math.abs(this.game.playerSnake.x) >= (GAME_WIDTH - (SCREEN_WIDTH / 2)) && this.game.playerSnake.x < 0) || (!this.game.id_follow_bot)) {

        //     this.ctx.rect(0, 0, BeginX, SCREEN_HEIGHT)
        // }
        // BeginX = GAME_WIDTH - (this.game.playerSnake.x - (GAME_WIDTH - (SCREEN_WIDTH / 2))) - (GAME_WIDTH - SCREEN_WIDTH) + 22
        // if ((Math.abs(this.game.playerSnake.x) >= (GAME_WIDTH - (SCREEN_WIDTH / 2)) && this.game.playerSnake.x >= 0) || (!this.game.id_follow_bot)) {

        //     this.ctx.rect(BeginX, 0, BeginX, SCREEN_HEIGHT)
        // }
        // BeginY = GAME_HEIGHT - (this.game.playerSnake.y - begining) - (GAME_HEIGHT - SCREEN_HEIGHT) + 22
        // if ((Math.abs(this.game.playerSnake.y) >= (GAME_HEIGHT - (SCREEN_HEIGHT / 2)) && this.game.playerSnake.y > 0) || (!this.game.id_follow_bot)) {

        //     this.ctx.rect(0, BeginY, SCREEN_WIDTH, BeginY)
        // }
        // this.ctx.fill()



    }
}
class Screen {
    constructor(game) {
        this.game = game;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
    }
    animatePulse(pos, styleProporties) {
        const ctx = this.game.ctx;
        const radius = styleProporties.width;

        // Изменение радиуса с помощью пульсации
        const pulseRadius = radius + Math.sin(Date.now() * 0.01) * 2;

        ctx.beginPath();
        ctx.arc(
            pos.x - this.left,
            pos.y - this.top,
            pulseRadius,
            0,
            Math.PI * 2
        );

        ctx.fillStyle = styleProporties.color;
        ctx.fill();
        ctx.strokeStyle = styleProporties.borderColor;
        ctx.stroke();
        ctx.closePath();
    }
    update() {
        if (this.game.store.isPhone) {
            if (Object.keys(this.game.snakes).length > 0) {
                if (!this.game.snakes[this.game.playerSnake.id]) {
                    
                    const random_key = Object.keys(this.game.snakes)[0];
                    this.game.playerSnake = this.game.snakes[random_key];
                    
                }

            }
        }



        this.top = this.game.playerSnake.y - (SCREEN_HEIGHT / 2);
        this.bottom = this.game.playerSnake.y + (SCREEN_HEIGHT / 2);
        this.left = this.game.playerSnake.x - (SCREEN_WIDTH / 2);
        this.right = this.game.playerSnake.x + (SCREEN_WIDTH / 2);
        // console.log("update",this.game.playerSnake)
    }
    justMoveDrawSpeed(pos, styleProporties, styleName) {
        const k = 1;
    }
    justMoveDraw(pos, styleProporties, styleName) {
        const ctx = this.game.ctx;
        if (!this.game.snakes[pos.id].visiable) {
            ctx.globalAlpha = 0.5;

        }
        let gradient = "";

        gradient = styleProporties.color;


        // if (styleName === "snack" && this.game.snakes[pos.id].speed!== FAST_SPEED){
        //     /*ctx.shadowColor = styleProporties.normalSpeed; // Цвет тени
        //     ctx.shadowBlur = 20; // Размытие тени*/
        //     const shadowColor = "rgba(28, 84, 176, 0.9)"
        //     ctx.beginPath();
        //     ctx.arc(pos.x - this.left, pos.y - this.top, styleProporties.width * 1.2, 0, 2 * Math.PI);
        //     ctx.fillStyle = shadowColor;
        //     ctx.fill();
        // }
        if (styleName === "snack" && this.game.snakes[pos.id].speed === FAST_SPEED) {
            const shadowColor = styleProporties.fastSpeed
            if (!this.game.isLowPhone) {
                ctx.beginPath();
                ctx.arc(pos.x - this.left, pos.y - this.top, styleProporties.width * 1.2, 0, 2 * Math.PI);

                ctx.fillStyle = shadowColor;
                ctx.fill();
            }
            // ctx.shadowColor = styleProporties.fastSpeed; // Цвет тени
            // ctx.shadowBlur = 50; // Размытие тени


        }





        ctx.beginPath();

        ctx.arc(
            pos.x - this.left,
            pos.y - this.top,
            styleProporties.width,
            0,
            Math.PI * 2
        );

        ctx.fillStyle = gradient;
        ctx.fill();
        ctx.strokeStyle = styleProporties.borderColor;
        ctx.stroke();
        ctx.closePath();
        ctx.globalAlpha = 1;


    }
    animateBlink(pos, styleProperties) {
        const ctx = this.game.ctx;
        const radius = styleProperties.width;
        const centerX = pos.x - this.left + radius * 0.5; // Сдвиг по оси X вправо на половину радиуса
        const centerY = pos.y - this.top;

        // Расчет координат для центральной области мигания
        const innerRadius = radius * 0.5;
        const innerX = centerX - innerRadius * 0.5;
        const innerY = centerY - innerRadius * 0.5;

        // Мигание центральной области
        const blinkOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Максимальная прозрачность 0.7, увеличен множитель

        // Рисование основного круга
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fillStyle = styleProperties.color;
        ctx.fill();
        ctx.strokeStyle = styleProperties.borderColor;
        ctx.stroke();

        // Рисование мигающей центральной области
        ctx.beginPath();
        ctx.arc(innerX, innerY, innerRadius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${blinkOpacity})`;
        ctx.fill();
        ctx.closePath();

        // Мигание тени круга
        const shadowOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Максимальная прозрачность 0.7, увеличен множитель
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius + styleProperties.width * 0.5, 0, Math.PI * 2); // Расширяем радиус тени
        ctx.fillStyle = `rgba(0, 0, 0, ${shadowOpacity})`;
        ctx.fill();
        ctx.closePath();
    }
    animateHead(pos, styleProperties, isAccelerating = true) {
        const ctx = this.game.ctx;
        const radius = styleProperties.width;
        const centerX = pos.x - this.left; // Shift along the X-axis to the right by half the radius
        const centerY = pos.y - this.top;

        // Calculation of coordinates for the blinking central area
        const innerRadius = radius * 0.5;
        const innerX = centerX - innerRadius * 0.5;
        const innerY = centerY - innerRadius * 0.5;

        // Blinking of the central area
        const blinkOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Maximum opacity of 0.7, increased multiplier

        // Pulsation animation
        const pulseRadius = radius + Math.sin(Date.now() * 0.01) * 2;

        // Calculate the offset for the eyes
        const eyeOffsetX = isAccelerating ? 2 : 0;
        const eyeOffsetY = isAccelerating ? 2 : 0;

        // Drawing the main circle
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fillStyle = styleProperties.color;
        ctx.fill();
        ctx.strokeStyle = styleProperties.borderColor;
        ctx.stroke();

        // Drawing the blinking central area
        ctx.beginPath();
        ctx.arc(innerX, innerY, innerRadius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${blinkOpacity})`;
        ctx.fill();
        ctx.closePath();

        // Blinking of the circle's shadow
        const shadowOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Maximum opacity of 0.7, increased multiplier
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius + styleProperties.width * 0.5, 0, Math.PI * 2); // Expand the shadow radius
        ctx.fillStyle = `rgba(0, 0, 0, ${shadowOpacity})`;
        ctx.fill();
        ctx.closePath();

        // Drawing the pulsating circle
        ctx.beginPath();
        ctx.arc(centerX, centerY, pulseRadius, 0, Math.PI * 2);
        ctx.strokeStyle = styleProperties.borderColor;
        ctx.stroke();
        ctx.closePath();

        // Drawing the eyes
        const eyeRadius = radius * 0.2;
        const leftEyeX = centerX - eyeRadius - eyeOffsetX;
        const rightEyeX = centerX + eyeRadius + eyeOffsetX;
        const eyeY = centerY + eyeOffsetY;

        ctx.beginPath();
        ctx.arc(leftEyeX, eyeY, eyeRadius, 0, Math.PI * 2);
        ctx.fillStyle = styleProperties.eyeColor;
        ctx.fill();
        ctx.closePath();

        ctx.beginPath();
        ctx.arc(rightEyeX, eyeY, eyeRadius, 0, Math.PI * 2);
        ctx.fillStyle = styleProperties.eyeColor;
        ctx.fill();
        ctx.closePath();
    }

    animateCircle(pos, styleProperties) {
        const ctx = this.game.ctx;
        const radius = styleProperties.width;
        const centerX = pos.x - this.left; // Сдвиг по оси X вправо на половину радиуса
        const centerY = pos.y - this.top;

        // Расчет координат для центральной области мигания
        const innerRadius = radius * 0.5;
        const innerX = centerX - innerRadius * 0.5;
        const innerY = centerY - innerRadius * 0.5;

        // Мигание центральной области
        const blinkOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Максимальная прозрачность 0.7, увеличен множитель

        // Мигание пульсации
        const pulseRadius = radius + Math.sin(Date.now() * 0.01) * 2;

        // Рисование основного круга
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fillStyle = styleProperties.color;
        ctx.fill();
        ctx.strokeStyle = styleProperties.borderColor;
        ctx.stroke();

        // Рисование мигающей центральной области
        ctx.beginPath();
        ctx.arc(innerX, innerY, innerRadius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${blinkOpacity})`;
        ctx.fill();
        ctx.closePath();

        // Мигание тени круга
        const shadowOpacity = Math.abs(Math.sin(Date.now() * 0.01)) * 0.7; // Максимальная прозрачность 0.7, увеличен множитель
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius + styleProperties.width * 0.5, 0, Math.PI * 2); // Расширяем радиус тени
        ctx.fillStyle = `rgba(0, 0, 0, ${shadowOpacity})`;
        ctx.fill();
        ctx.closePath();

        // Рисование пульсирующего круга
        // ctx.beginPath();
        // ctx.arc(centerX, centerY, pulseRadius, 0, Math.PI * 2);
        // ctx.strokeStyle = styleProperties.borderColor;
        // ctx.stroke();
        // ctx.closePath();
    }
    drawCirclePlayer(pos, styleName) {
        const id = pos.id;
        const circleX = pos.x;
        const circleY = pos.y;
        const circleRadius = this.game.snakes[pos.id].width;
        const isCircleVisible =
            circleX + circleRadius >= this.left &&
            circleX - circleRadius <= this.right &&
            circleY + circleRadius >= this.top &&
            circleY - circleRadius <= this.bottom;
        if (isCircleVisible) {


            let styleProperties = new Styles(this.game.snakes[pos.id].color, this.game.snakes[pos.id].width, false, this.game.socket).resStyle[styleName];
            // let styleProperties = 0;
            //
            // if (this.game.snakes[pos.id].speed === this.game.snakes[pos.id].fastSpeed && styleName === "eye"){
            //     this.animateCircle(pos, new Styles(this.game.snakes[pos.id].color , this.game.snakes[pos.id].width , true).resStyle[styleName]);
            // } else if (this.game.snakes[pos.id].speed === this.game.snakes[pos.id].fastSpeed && styleName === "snack" && pos.x !== this.game.playerSnake.x) {
            //     this.animateCircle(pos, styleProperties);
            // } else {
            if (styleProperties) {
                this.justMoveDraw(pos, styleProperties, styleName);

            } else {

                this.justMoveDraw(pos, new Styles("blue", this.game.snakes[pos.id].width, false, this.game.socket).resStyle[styleName], styleName)
            }
        }
    }
    drawCircle(pos, styleName) {
        // console.log(this.game.snakes[pos.id].color)
        let styleProperties = new Styles(this.game.snakes[pos.id].color, this.game.snakes[pos.id].width, false, this.game.socket).resStyle[styleName];
        const circleX = pos.x;
        const circleY = pos.y;
        const circleRadius = styleProperties.width;
        const isCircleVisible =
            circleX + circleRadius >= this.left &&
            circleX - circleRadius <= this.right &&
            circleY + circleRadius >= this.top &&
            circleY - circleRadius <= this.bottom;
        if (isCircleVisible) {
            // if (this.game.playerSnake.speed === this.game.playerSnake.fastSpeed && styleName === "eye"){
            //
            //     this.animateBlink(pos, styleProperties);
            // } else if (this.game.playerSnake.speed === this.game.playerSnake.fastSpeed && styleName === "snack" && pos.x !== this.game.playerSnake.x) {
            //     this.animateCircle(pos, styleProperties);
            // } else {

            if (styleName === "black" && this.game.snakes[pos.id].speed === FAST_SPEED) {
                styleProperties.color = "red";
                styleProperties.borderColor = "red";
            }

            this.justMoveDraw(pos, styleProperties, styleName, this.game.snakes[pos.id].image);
        }
        // }
    }
    drawLineEnd(pos) {
        const ctx = this.game.ctx;

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(SCREEN_WIDTH, SCREEN_HEIGHT);
        ctx.stroke();
        ctx.closePath();
    }
}

const EYE_ANGLE = 1;
const BLACK_DOT_OFFSET_X = 10; // Смещение по оси X
const BLACK_DOT_OFFSET_Y = -2; // Смещение по оси Y
const MAX_BLACK_DOT_DISTANCE = 5; // Максимальное расстояние от центра глаза до черной точки

class Eye {
    constructor(snake) {
        this.snake = snake;
        this.mouseX = 0;
        this.mouseY = 0;
        this.EYE_DISTANCE = this.snake.width / 2 + 5;
        // Добавляем обработчик события перемещения мыши
        document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    }

    handleMouseMove(event) {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
    }

    draw() {
        let eye1Pos = 0;
        let eye2Pos = 0;

        if (this.snake.speed === this.snake.fastSpeed) {
            eye1Pos = this.calculateEyePosition(this.snake.angle - EYE_ANGLE);
            this.snake.game.screen.drawCircle(eye1Pos, "eye");

            eye2Pos = this.calculateEyePosition(this.snake.angle + EYE_ANGLE);
            this.snake.game.screen.drawCircle(eye2Pos, "eye");
        } else {
            eye1Pos = this.calculateEyePosition(this.snake.angle - EYE_ANGLE);
            this.snake.game.screen.drawCircle(eye1Pos, "eye");

            eye2Pos = this.calculateEyePosition(this.snake.angle + EYE_ANGLE);
            this.snake.game.screen.drawCircle(eye2Pos, "eye");
        }

        if (this.snake.speed !== this.snake.fastSpeed) {
            this.snake.game.screen.drawCircle(eye1Pos, "black");
            this.snake.game.screen.drawCircle(eye2Pos, "black");
        } else {
            this.snake.game.screen.drawCircle(eye1Pos, "black");
            this.snake.game.screen.drawCircle(eye2Pos, "black");
        }
    }

    calculateEyePosition(angle) {
        const eyeX = this.snake.x + Math.cos(angle) * this.EYE_DISTANCE;
        const eyeY = this.snake.y + Math.sin(angle) * this.EYE_DISTANCE;

        return { x: eyeX, y: eyeY, id: this.snake.id };
    }

    calculateBlackDotPosition(eyePos, angle) {
        const offsetX = Math.cos(angle) * (this.EYE_DISTANCE + BLACK_DOT_OFFSET_X);
        const offsetY = Math.sin(angle) * (this.EYE_DISTANCE + BLACK_DOT_OFFSET_Y);

        const blackDotX = eyePos.x + offsetX;
        const blackDotY = eyePos.y + offsetY;

        return { x: blackDotX, y: blackDotY };
    }

    isInsideWhiteCircle(point, eyePos) {
        const distance = Math.sqrt(
            (point.x - eyePos.x) ** 2 + (point.y - eyePos.y) ** 2
        );
        return distance <= MAX_BLACK_DOT_DISTANCE;
    }
}

class Food {
    constructor(game, id, x, y, radius) {
        this.game = game;
        this.ctx = this.game.ctx;
        this.radius = radius;
        this.x = x;
        this.id = id;
        this.y = y;
        this.scaleFactor = 1; // Множитель для пульсации
        this.scaleDirection = 1; // Направление пульсации
        this.hue = 0; // Оттенок цвета
    }

    draw() {

        const playerSnake = this.game.playerSnake;
        const screen_WIDTH = SCREEN_WIDTH;
        const screen_HEIGHT = SCREEN_HEIGHT;


        const foodX = this.x - playerSnake.x + screen_WIDTH / 2;
        const foodY = this.y - playerSnake.y + screen_HEIGHT / 2;
        const circleX = this.x;
        const circleY = this.y;

        // Радиус круга
        const circleRadius = this.radius * this.scaleFactor;
        const isCircleVisible =
            circleX + circleRadius >= this.game.screen.left &&
            circleX - circleRadius <= this.game.screen.right &&
            circleY + circleRadius >= this.game.screen.top &&
            circleY - circleRadius <= this.game.screen.bottom;
        if (isCircleVisible) {


            // Рисуем круг
            this.ctx.beginPath();
            this.ctx.arc(foodX, foodY, this.radius * this.scaleFactor, 0, Math.PI * 2);
            this.ctx.fillStyle = "hsl(" + this.hue + ", 100%, 50%)";
            this.ctx.fill();
            this.ctx.closePath();

            // Обновляем множитель для пульсации
            this.scaleFactor += 0.05 * this.scaleDirection;

            // Проверяем границы для пульсации
            if (this.scaleFactor >= 1.5) {
                this.scaleDirection = -1;
            } else if (this.scaleFactor <= 1) {
                this.scaleDirection = 1;
                this.hue += 5; // Изменяем оттенок цвета при уменьшении
            }

            // Проверяем границы для оттенка цвета
            if (this.hue >= 360) {
                this.hue = 0;
            }
        }

    }
}
class Snake {
    constructor(game, x, y, speed) {
        this.game = game;
        this.x = x;
        this.y = y;
        this.foodCount = 0;
        this.grownCount = 0;
        this.cash = 0;
        this.angle = 0;
        this.downCount = 0;
        this.speed = speed;
        this.count = 0;
        this.downCash = 0;
        this.tailPositions = [];
        this.kroud = 5;
        this.width = 20;

        // this.fastSpeed = 10l

    }

    createTail() {
        for (let i = 0; i < 100; i++) {
            this.tailPositions.push({
                x: this.x - (i * this.speed), // Используем this.speed вместо SNAKE_SPEED
                y: this.y,
                width: this.width
            });
        }
    }

    update() {
        let what_pop = 0;
        let what_append = {};
        let newTailPosition = {
            x: this.x + Math.cos(this.angle) * this.speed,
            y: this.y + Math.sin(this.angle) * this.speed,
            width: this.width
        };
        if (this.tailPositions.length <= 6) {
            this.speed = 1; // Изменяем скорость змейки
        }
        if (this.speed === this.fastSpeed && this.game.miniSizeSnake < this.tailPositions.length) {
            this.downCount += 1;
            this.downCash += 1;
            if (this.downCash >= 9) {

                this.cash -= this.game.cost * 0.01;
                this.game.socket.emit("ChangeCash")
                if (this.cash < this.game.cost * 0.01) {
                    this.cash = 0


                }
                this.game.socket.emit("NewFood")

                this.downCash = 0;
            }

            if (this.downCount >= 9) {
                this.tailPositions.pop()
                what_pop += 1;
                this.downCount = 0;
            }
            // setTimeout(()=>{
            //     this.tailPositions.pop()
            //     this.downCount =0;
            // })
            this.tailPositions.unshift(newTailPosition);
            what_append = newTailPosition;
            if (this.grownCount < 1) {
                this.tailPositions.pop();
                what_pop += 1;

            } else {
                this.grownCount -= 1;
                this.game.socket.emit("ChangeGrownCount", this.game.BSON.serialize({ grownCount: this.grownCount }))

            }
            this.cash = Math.round(this.cash * 100) / 100
            document.querySelector(".balance h1").innerHTML = `${STRING_BALANCE}` + `<span>${this.cash}` + "$</span>"
            this.x += Math.cos(this.angle) * this.speed;
            this.y += Math.sin(this.angle) * this.speed;
            // Increase speed of x and y coordinates
            // this.x += Math.cos(this.angle) * this.speed;
            // this.y += Math.sin(this.angle) * this.speed;
            this.game.socket.emit("Player_Move", this.game.BSON.serialize({
                x: this.x,
                y: this.y,
                what_pop: what_pop,
                what_append: what_append
            }
            ))
        }
        else if (this.speed === this.fastSpeed && this.game.miniSizeSnake >= this.tailPositions.length) {
            this.speed = SNAKE_SPEED;
            this.game.socket.emit("ChangeSpeed", this.game.BSON.serialize({ speed: this.speed }))

        }
        else {
            this.tailPositions.unshift(newTailPosition);
            what_append = newTailPosition;
            if (this.grownCount < 1) {
                this.tailPositions.pop();
                what_pop += 1;

            }
            else {
                this.grownCount -= 1;
                this.game.socket.emit("ChangeGrownCount", this.game.BSON.serialize({ grownCount: this.grownCount }))
            }
            this.cash = Math.round(this.cash * 100) / 100
            document.querySelector(".balance h1").innerHTML = `${STRING_BALANCE}` + `<span>${this.cash}` + "$</span>"

            //
            this.x = newTailPosition.x;
            this.y = newTailPosition.y;
            if (this.isPlayer) {
                const data_For_Serealize = {
                    x: this.x + Math.cos(this.angle) * this.speed,
                    y: this.y + Math.sin(this.angle) * this.speed,
                    // width: this.width,
                    what_pop: what_pop,
                    what_append: what_append
                }

                this.game.socket.emit("Player_Move", this.game.BSON.serialize(data_For_Serealize))
            }
        }
    }
    // update(){
    //     let newTailPosition = {
    //         x: this.x + Math.cos(this.angle) * this.speed,
    //         y: this.y + Math.sin(this.angle) * this.speed,
    //         width: this.width
    //     };
    //     this.game.socket.emit("Player_Move")
    // }
}
class OtherPlayer extends Snake {
    constructor(game, name, x, y, tailPositions, visiable, id, angle, speed, fastSpeed, cash, downCash, grownCount, downCount, width, color, death, role) {
        super(game, x, y, speed);
        this.speed = speed;
        this.CheckPos = true;
        this.role = role;
        this.visiable = visiable;

        this.eye = new Eye(this);
        this.death = death;
        this.isDraw = true;
        this.name = name;
        this.id = id;
        this.cursor = 0;
        this.c = 0;
        this.isPlayer = true;
        this.width = width;
        this.angle = angle;
        this.downCash = downCash;
        this.color = color;
        this.changeColor = this.game.colors[color] ? true : false;
        this.animateColor = this.game.colorsAnimate[color] ? true : false;

        if (this.changeColor) {
            this.colors = this.game.colors[color];
        }
        if (this.animateColor) {
            const colors = this.game.colorsAnimate[color];
            this.color = colors[0];
            setInterval(() => {
                this.cursor++;
                if (this.cursor >= colors.length) {
                    this.cursor = 0;
                }
                this.color = colors[this.cursor]
            }, 800)
        }
        this.fastSpeed = fastSpeed;
        this.tailPositions = tailPositions;
        this.downCount = downCount;
        this.cash = cash;
        this.grownCount = grownCount;
    }

    update() {


        let newTailPosition = {
            x: this.x + Math.cos(this.angle) * this.speed,
            y: this.y + Math.sin(this.angle) * this.speed,
            width: this.width
        };


        if (this.speed === this.fastSpeed && this.game.miniSizeSnake < this.tailPositions.length) {
            this.downCount += 1;
            if (this.downCount >= 9) {
                this.tailPositions.pop()
                this.downCount = 0;
            }
            // setTimeout(()=>{
            //     this.tailPositions.pop()
            //     this.downCount =0;
            // })
            this.tailPositions.unshift(newTailPosition);
            if (this.grownCount < 1) {
                this.tailPositions.pop();

            } else {
                this.grownCount -= 1;
            }
            // Increase speed of x and y coordinates
            // this.x += Math.cos(this.angle) * this.speed;
            // this.y += Math.sin(this.angle) * this.speed;
        } else {
            this.tailPositions.unshift(newTailPosition);
            if (this.grownCount < 1) {
                this.tailPositions.pop();

            } else {
                this.grownCount -= 1;
            }

            // this.x = newTailPosition.x;
            // this.y = newTailPosition.y;

        }
    }




    draw() {

        const headPos = { x: this.x, y: this.y, width: this.width, id: this.id };
        if (!this.death) {


            // if (this.speed !== this.fastSpeed) {
            //     for (let i = this.tailPositions.length - 1; i > 1; i -= 8) {
            //         const pos = this.tailPositions[i];
            //
            //         this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
            //     }
            // } else {
            //     for (let i = this.tailPositions.length - 1; i > 1; i -= 2) {
            //         const pos = this.tailPositions[i];
            //         this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
            //     }
            // }
            // Рисуем тень

            if (this.speed !== this.fastSpeed) {
                const much = Math.ceil((this.width - 20) / 10)
                const step = 2 + much;
                let cont;
                if (this.changeColor) {
                    cont = Math.floor((Math.floor(this.tailPositions.length / step) + 1) / this.colors.length);
                    this.cursor = 0;
                    this.c = 0;
                }
                for (let i = this.tailPositions.length - 1; i > 1; i -= step) {
                    const pos = this.tailPositions[i];
                    if (this.changeColor) {

                        this.color = this.colors[this.cursor];
                        this.c += 1;
                        if (this.c === cont) {
                            this.cursor++;
                            if (this.cursor >= this.colors.length) {

                                this.cursor = this.colors.length - 1;
                            }
                            this.c = 0;
                        }
                    }

                    // this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
                    this.game.screen.drawCirclePlayer({ x: pos.x, y: pos.y, id: this.id }, "snack");
                }

            } else {

                const much = Math.ceil((this.width - 20) / 10)
                const step = (this.game.isLowPhone ? 2 : 1) + much;
                let cont;
                if (this.changeColor) {
                    cont = Math.floor((Math.floor(this.tailPositions.length / step) + 1) / this.colors.length);

                    this.cursor = 0;
                    this.c = 0;
                }
                for (let i = this.tailPositions.length - 1; i > 1; i -= step) {
                    const pos = this.tailPositions[Math.floor(i)];
                    if (this.changeColor) {
                        this.color = this.colors[this.cursor];
                        this.c += 1;
                        if (this.c === cont) {
                            this.cursor++;
                            if (this.cursor >= this.colors.length) {
                                this.cursor = this.colors.length - 1;
                            }
                            this.c = 0;
                        }
                    }
                    // this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
                    this.game.screen.drawCirclePlayer({ x: pos.x, y: pos.y, id: this.id }, "snack");
                }
                // this.game.screen.drawCirclePlayer({x: this.tailPositions[step].x, y: this.tailPositions[step].y, id: this.id}, "snack");

            }
            // Рисуем тело

            // Рисуем голову

            this.game.screen.drawCirclePlayer(headPos, "snack");
            this.game.ctx.beginPath();
            const text = this.name;
            const centerX = SCREEN_WIDTH / 2; // Центр по оси X
            const centerY = SCREEN_HEIGHT / 2; // Центр по оси Y
            if (this.role === "streamer") {
                this.game.ctx.fillStyle = '#5C62EC';
            }
            else {
                this.game.ctx.fillStyle = 'white';
            }

            this.game.ctx.font = '15px Arial';

            const angle = 45; // Угол наклона текста (в градусах)
            const radians = angle * Math.PI / 180; // Переводим угол в радианы
            this.game.ctx.fillText(text, this.x - this.game.screen.left + this.width / 2 + Math.cos(radians) * 30, this.y - this.game.screen.top + this.width / 2 + Math.sin(radians) * 15);
            this.game.ctx.closePath()

            // Рисуем глаза
            this.eye.draw();

        }
        else {
            this.game.screen.drawCirclePlayer(headPos, "snack");

            this.game.ctx.beginPath();
            const text = this.name;
            const centerX = SCREEN_WIDTH / 2; // Центр по оси X
            const centerY = SCREEN_HEIGHT / 2; // Центр по оси Y
            if (this.role === "streamer") {
                this.game.ctx.fillStyle = '#5C62EC';
            }
            else {
                this.game.ctx.fillStyle = 'white';
            }

            this.game.ctx.font = '15px Arial';

            const angle = 45; // Угол наклона текста (в градусах)
            const radians = angle * Math.PI / 180; // Переводим угол в радианы
            this.game.ctx.fillText(text, this.x - this.game.screen.left + this.width / 2 + Math.cos(radians) * 30, this.y - this.game.screen.top + this.width / 2 + Math.sin(radians) * 15);
            this.game.ctx.closePath()

            // Рисуем глаза
            this.eye.draw();
        }

    }

}
//import {BSON , EJSON} from "../libs/bson.mjs";

class PlayerSnake extends Snake {
    constructor(game, name, x, y, speed, fastSpeed, tailPositions, id, cash, downCash, grownCount, downCount, width, color, death, role) {
        super(game, x, y, speed);
        this.x = x;
        this.role = role;
        this.y = y;
        this.name = name;
        this.visiable = false;
        this.bonus_food = 0;
        this.color = color;
        this.death = death;
        this.cursor = 0;
        this.c = 0;
        const self = this;
        this.animationFrameId = null;
        this.speed = speed;
        this.isPlayer = true;
        this.schemaAngle = schemapack.build({ angle: "int16" });
        this.changeColor = this.game.colors[color] ? true : false;
        this.animateColor = this.game.colorsAnimate[color] ? true : false;
        if (this.changeColor) {
            this.colors = this.game.colors[color];
        }
        if (this.animateColor) {
            const colors = this.game.colorsAnimate[color];
            this.color = colors[0];
            setInterval(() => {
                this.cursor++;
                if (this.cursor >= colors.length) {
                    this.cursor = 0;
                }
                this.color = colors[this.cursor]
            }, 800)
        }
        this.width = width;
        this.eye = new Eye(this);
        this.cash = cash;
        this.angle2 = 0;
        let image = new Image();
        image.src = "assets/body.png";
        this.grownCount = grownCount;
        this.downCount = downCount;
        this.tailPositions = tailPositions;
        this.downCash = downCash;
        this.id = id;
        this.listenMouseEvent();
        this.listenTouchEvent();
        this.fastSpeed = fastSpeed;
        this.btn = document.querySelector(".acceleration-button");

    }


    listenTouchEvent() {

        this.game.canvas.addEventListener("touchmove", (e) => {
            var rect = this.game.canvas.getBoundingClientRect();
            this.processMouseMove({
                x: e.touches[0].pageX - this.game.canvas.offsetLeft,
                y: e.touches[0].pageY - this.game.canvas.offsetTop
            })
            this.btn.addEventListener("touchstart", () => {
                if (this.game.miniSizeSnake < this.tailPositions.length) {
                    this.speed = this.fastSpeed;
                    this.game.socket.send(this.game.pack({ event: "ChangeSpeed", speed: this.speed }))
                }
            });
            this.btn.addEventListener("touchend", () => {
                this.speed = SNAKE_SPEED;
                this.game.socket.send(this.game.pack({ event: "ChangeSpeed", speed: this.speed }))

            });
        });
    }
    listenMouseEvent() {
        this.game.canvas.addEventListener("mousemove", (e) => {
            var rect = this.game.canvas.getBoundingClientRect();
            this.processMouseMove({
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            });
        });
        this.game.canvas.addEventListener("mousedown", () => {
            if (this.game.miniSizeSnake < this.tailPositions.length || this.death) {
                this.speed = this.fastSpeed;
                this.game.socket.send(this.game.pack({ event: "ChangeSpeed", speed: this.speed }))

            }
        });
        this.game.canvas.addEventListener("mouseup", () => {
            this.speed = SNAKE_SPEED;
            this.game.socket.send(this.game.pack({ event: "ChangeSpeed", speed: this.speed }))

        });
    }

    update() {

        // this.checkCollisions();
        // this.checkFoodCollision();
        super.update();
    }

    processMouseMove(mousePos) {
        // const targetAngle = Math.atan2(
        //     mousePos.y - (this.y-this.game.screen.top),
        //     mousePos.x - (this.x- this.game.screen.left)
        //
        // );
        const targetAngle = Math.atan2(
            mousePos.y - (SCREEN_HEIGHT / 2),
            mousePos.x - (SCREEN_WIDTH / 2)

        );


        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
        this.animationFrameId = requestAnimationFrame(() => {
            const angle_rads = Math.floor(targetAngle * (180 / Math.PI))
            this.game.socket.send(this.schemaAngle.encode({ angle: angle_rads }));
            this.animationFrameId = null;
        });
    }

    draw() {

        const headPos = { x: this.x, y: this.y, width: this.width, id: this.id };
        if (!this.death) {


            // if (this.speed !== this.fastSpeed) {
            //     for (let i = this.tailPositions.length - 1; i > 1; i -= 8) {
            //         const pos = this.tailPositions[i];
            //
            //         this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
            //     }
            // } else {
            //     for (let i = this.tailPositions.length - 1; i > 1; i -= 2) {
            //         const pos = this.tailPositions[i];
            //         this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
            //     }
            // }
            // Рисуем тень

            if (this.speed !== this.fastSpeed) {
                const much = Math.ceil((this.width - 20) / 10)
                const step = 2 + much;
                let cont;
                if (this.changeColor) {
                    cont = Math.floor((Math.floor(this.tailPositions.length / step) + 1) / this.colors.length);
                    this.cursor = 0;
                    this.c = 0;
                }
                for (let i = this.tailPositions.length - 1; i > 1; i -= step) {
                    const pos = this.tailPositions[i];
                    if (this.changeColor) {

                        this.color = this.colors[this.cursor];
                        this.c += 1;
                        if (this.c === cont) {
                            this.cursor++;
                            if (this.cursor >= this.colors.length) {

                                this.cursor = this.colors.length - 1;
                            }
                            this.c = 0;
                        }
                    }
                    // this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
                    this.game.screen.drawCirclePlayer({ x: pos.x, y: pos.y, id: this.id }, "snack");
                }

            } else {

                const much = Math.ceil((this.width - 20) / 10)
                const step = 1 + much;
                let cont;
                if (this.changeColor) {
                    cont = Math.floor((Math.floor(this.tailPositions.length / step) + 1) / this.colors.length);

                    this.cursor = 0;
                    this.c = 0;
                }
                for (let i = this.tailPositions.length - 1; i > 1; i -= step) {
                    const pos = this.tailPositions[Math.floor(i)];
                    if (this.changeColor) {
                        this.color = this.colors[this.cursor];
                        this.c += 1;
                        if (this.c === cont) {
                            this.cursor++;
                            if (this.cursor >= this.colors.length) {
                                this.cursor = this.colors.length - 1;
                            }
                            this.c = 0;
                        }
                    }
                    // this.game.screen.drawCirclePlayer({x: pos.x, y: pos.y, id: this.id}, "shadow");
                    this.game.screen.drawCirclePlayer({ x: pos.x, y: pos.y, id: this.id }, "snack");
                }
                // this.game.screen.drawCirclePlayer({x: this.tailPositions[step].x, y: this.tailPositions[step].y, id: this.id}, "snack");

            }
            // Рисуем тело

            // Рисуем голову

            this.game.screen.drawCirclePlayer(headPos, "snack");



            // Рисуем глаза
            this.eye.draw();

        }
        else {
            this.game.screen.drawCirclePlayer(headPos, "snack");



            // Рисуем глаза
            this.eye.draw();
        }

    }
}
class Game {
    constructor({ setLoadingGame, setLast10, setStatus_switch_bil, setDemo_balance, setBetsInf, setWinnerName, setTopFiveNumbers, setSeconds, setGameStatus, setWinner_balance, setWinner, setOnline, setTableUsers, setError, setLoadUser }, { gameFieldSelector }, store, room, user, cost, socket, skin, type, typeString, role, id_user, choice_pay, client_url) {
        this.socket = socket;
        this.store = store;
        this.setWinnerName = setWinnerName;
        this.setLast10 = setLast10;
        this.setDemo_balance = setDemo_balance;
        this.setStatus_switch_bil = setStatus_switch_bil;
        this.setError = setError;
        this.setWinner_balance = setWinner_balance;
        this.setBetsInf = setBetsInf;
        this.gameFieldSelector = gameFieldSelector;
        this.setLoadingGame = setLoadingGame;
        this.setGameStatus = setGameStatus;
        this.setTopFiveNumbers = setTopFiveNumbers;
        this.setSeconds = setSeconds
        this.setLoadUser = setLoadUser;
        this.setOnline = setOnline
        this.setWinner = setWinner;
        this.online = 0;
        this.idFrameDraw = null;
        this.setTableUsers = setTableUsers
        this.isDraw = true;
        this.role = role;
        this.counter = 0;
        this.client_url = client_url;
        this.showFail = false;
        this.id_follow_bot = null;
        this.seconds = 0;
        this.intervalCheckAparat = null;
        this.isLowPhone = false
        this.showSuccses = false;
        this.currentZoomLevel = 1;
        this.fps = 0;
        this.flagFps = true;
        this.checkTime = performance.now();
        this.type = type;
        this.isLowPhoneImid = false;
        this.following_bot = false
        this.link_redirect = ""
        this.typeString = typeString

        if (this.typeString === "cost") {
            this.link_redirect = client_url + "/list_room_cost"

        }
        else {
            this.link_redirect = client_url + "/enter_room_free"
        }
        this.isDrawNumber = false;
        this.formatTime = (time) => {

            const minutes = Math.floor((time % 3600) / 60);
            const seconds = time % 60;

            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };
        this.numberEnd = 6;
        this.lastFrameTime = performance.now();
        this.framesThisSecond = 0;
        this.colors = { "russia": ["red", "blue", "white"], "ukraine": ["gold", "blue"], "armenia": ["gold", "blue", "red"], "belorus": ["green", "red"] }
        this.colorsAnimate = { "russia_animate": ["white", "blue", "red"], "twitch_animate": ["twitch", "red", "green", "gold"] }
        this.loadflag = false;
        this.startTimePing = 0;
        this.pingServer = 0
        this.animationFrameId = null;
        this.schema = schemapack.build([{
            x: "float32",
            y: "float32",
            angle: "int16",
            speed: "int8",
            width: "float32",
            what_pop: "int8",
            cash: "float32",
            id: "string"
        }])
        this.mainSchema = schemapack.build({
            event: "string",
            data: "buffer"
        })
        this.schemaAngle = schemapack.build({ angle: "int16" });

        this.foodShema = schemapack.build({
            id: "int32",
            id_p: "string",
            width: "float32",
            cash: "float32"
        })
        this.draw = this.draw.bind(this);
        this.pingCords = 0;
        this.tableTop = {}
        const medalToFirst = new Image()
        const medalToSecond = new Image()
        const medalToThird = new Image()

        medalToFirst.src = NAME_SERVER + "/gold-medal.png"

        medalToSecond.src = NAME_SERVER + "/silver-medal.png"
        medalToThird.src = NAME_SERVER + "/third-medal.png"
        const self = this;
        medalToFirst.onload = function () {
            self.medalFirst = medalToFirst;

        }
        medalToSecond.onload = function () {
            self.medalSecond = medalToSecond;
        }
        medalToThird.onload = function () {
            self.medalThird = medalToThird;
        }

        this.lastLoop = new Date();
        this.socket.addEventListener('open', () => {

            this.socket.send(this.pack({ event: 'connect_Room', data: { room_id: room, id_user, name: user, cost, skin, type, typeString, role, choice_pay, SCREEN_WIDTH: document.documentElement.clientWidth, SCREEN_HEIGHT: document.documentElement.clientHeight } }));
        });
        socket.addEventListener("close", () => {

            // window.location.reload()
        })
        window.addEventListener("online", () => {
            window.location.replace(this.link_redirect)
        })
        window.addEventListener('offline', () => {
            // console.error("Соединение потеряно")

            this.socket.send(this.pack({ event: 'connection_lost', data: {} }));


        });
        // socket.addEventListener('close', () => {
        //     this.socket.send(this.pack({event: 'connection_lost', data: {}}));
        //     window.location.replace(this.link_redirect)
        //
        // });
        socket.addEventListener('message', async (eventClient) => {
            const dataClient = this.mainSchema.decode(eventClient.data)

            // const dataClient = this.unpack(eventClient.data);
            const event = dataClient.event;
            let data = dataClient.data;
            if (dataClient.event.length > 1) {
                data = this.unpack(data);
            }
            if (event === "ChangeInfData") {
                this.setTopFiveNumbers(this.preobr_topFive(data.topFive))
                this.setLast10(this.preobr_last10(data.last10))
            }
            if (event === "2") {
                data = this.foodShema.decode(data)
                const check_is_bonus_food = data.cash === this.snakes[data.id_p].cash;
                delete this.foods[data.id]
                this.snakes[data.id_p].width = data.width;
                this.snakes[data.id_p].eye.EYE_DISTANCE = data.width / 2 + 5;
                this.snakes[data.id_p].cash = data.cash;

            }

            if (event === "1") {
                let perfom = performance.now();

                const dataUpdate = this.schema.decode(data);
                this.fill_players();
                if (this.snakes) {


                    for (let i = 0; i < dataUpdate.length; i++) {
                        const data = dataUpdate[i];
                        const key = data.id;

                        if (this.snakes[key]) {

                            const what_pop = data.what_pop;

                            const x = data.x;
                            const y = data.y;
                            if ((x > (GAME_WIDTH + 10) || x < (-GAME_WIDTH - 10) || y > (GAME_HEIGHT + 10) || y < (-GAME_HEIGHT - 10)) && this.snakes[key].role === "bot") {
                                this.socket.send(this.pack({ event: "MapsOver", data: { id: data.id } }));
                            }
                            this.snakes[key].x = data.x;
                            this.snakes[key].y = data.y;

                            // if (key !== this.playerSnake.id){
                            // console.log(180*data.angle/Math.PI , 180*this.snakes[key].angle/Math.PI)
                            data.angle = data.angle * (Math.PI / 180)
                            this.snakes[key].angle = data.angle;


                            // }
                            this.snakes[key].tailPositions.unshift({ x, y });
                            if (data.speed !== -1) {
                                this.snakes[key].speed = data.speed === 1 ? SNAKE_SPEED : FAST_SPEED;
                            }
                            if (data.width !== -1) {
                                this.snakes[key].width = data.width;
                                this.snakes[key].eye.EYE_DISTANCE = data.width / 2 + 5;
                            }

                            for (let i = 0; i < what_pop; i++) {
                                this.snakes[key].tailPositions.pop();
                            }


                        }

                    }
                    if (this.id_follow_bot) {
                        if (!this.snakes[this.id_follow_bot]) {
                            this.findBot()

                        }
                        else {
                            this.playerSnake.x = this.snakes[this.id_follow_bot].x
                            this.playerSnake.y = this.snakes[this.id_follow_bot].y

                        }
                    }

                    const fps = performance.now() - perfom;
                    if (fps > 5 && !this.flagFps && !this.isLowPhoneImid) {
                        this.isLowPhone = true;
                    }
                    if (fps < 3 && !this.flagFps && !this.isLowPhoneImid) {
                        this.isLowPhone = false;
                    }
                    if (fps < 3 && this.flagFps) {
                        this.loadflag = true;
                        this.socket.send(this.pack({ event: "loadUser" }));


                        this.flagFps = false;
                        clearInterval(this.intervalCheckAparat)

                    }
                    // this.draw();

                }
            }
            if (event === "WinnerRoulete") {


                document.querySelector(".gameCont").style.opacity = 0.1;
                document.querySelector(".count_players").remove();
                // if (document.querySelector("#contBetsInf")) {
                //     document.querySelector("#contBetsInf").style.opacity = 0.5;

                // }

                // document.querySelector("")

                this.setTopFiveNumbers(this.preobr_topFive(data.topFive))
                this.setLast10(this.preobr_last10(data.last10))
                this.setWinner(data.skin);
                this.setWinnerName(data.name)
                this.setWinner_balance(data.new_balance);
                if (data.new_balance>0){
                    Sound_play(sound_winGAME,store.sound)
                }

                setBetsInf(data.bets_succses)
                if (data.balance_user && data.type_bets === "real") {

                    this.store.user.balance = data.balance_user;




                }







                setTimeout(() => {
                    this.setWinner("")
                    this.setGameStatus(false);
                    this.setBetsInf([])
                    document.querySelector(".gameCont").style.opacity = 1;
                    document.querySelector("canvas").style.opacity=0.6;
                    


                    // document.querySelector("#mainGame").style.opacity = 1;
                    this.setStatus_switch_bil(true)
                }, 3000)
            }

            if (event === "already_have") {
                this.store.add_message("error3", ErrorComponent)


            }
            if (event === "load") {



                this.follow_ping_server();
                this.snakes[this.playerSnake.id] = this.playerSnake;
                document.querySelector("canvas").style.display = "block";

                document.querySelector("#container").style.display = "flex";
                document.querySelector(".spin").remove();
                document.querySelector(".closeContLoad").remove();
                // this.setLoadUser(true);
            }
            if (event === "pong") {
                const endTime = Date.now()
                this.ping = endTime - this.startTimePing;
                if (this.ping >= 60) {
                    document.querySelector(".wifi-block").style.display = "flex"
                }
                else {
                    document.querySelector(".wifi-block").style.display = "none"

                }
            }

            if (event === "changeVisiable") {
                this.snakes[data.id].visiable = true;

            }
            if (event === "changeSecond") {
                this.setSeconds(data)
            }
            if (event === "connectedRoom") {
                if (data.last10) {
                    this.setLast10(this.preobr_last10(data.last10))

                }
                if (data.topFive) {
                    this.setTopFiveNumbers(this.preobr_topFive(data.topFive))

                }
                if (data.statusGame) {
                    this.setStatus_switch_bil(false);
                }
                this.setGameStatus(data.statusGame);

                this.setSeconds(data.second)
                this.setLoadingGame(false);



                window.cancelAnimationFrame(this.idFrameDraw);

                this.idFrameDraw = window.requestAnimationFrame(this.draw)


                this.intervalCheckAparat = setInterval(() => {
                    this.seconds += 1;
                    if (this.seconds === 11) {
                        this.isLowPhone = true;
                        this.isLowPhoneImid = true;
                    }
                }, 1000)


                this.cost = cost


                this.room = room;
                this.foods = {}


                this.snakes = {};
                this.names = {};
                this.botSnakes = []

            }
            if (event === "initPlayers") {
                this.createOtherSnakes(data);
                // this.findBot()
                // this.updateOnline()

            }
            if (event === "startGame") {
                // this.setGameStatus(true);
                console.log("start")


                if (document.querySelector("canvas")) {


                    document.querySelector("canvas").remove()
                }
                if (document.querySelector(".count_players")){
                    document.querySelector(".count_players").remove();
                }
                this.canvas = document.createElement("canvas");
                this.canvas.classList.add("canvas"); // Замените "your-class-name" на нужное имя класса
                const container_players = document.createElement("div");
                container_players.classList.add("count_players");
                this.fill_players();
                

                // this.canvas.setAttribute("style", `width: ${SCREEN_WIDTH}px; height: ${SCREEN_HEIGHT}px; margin: 0; padding: 0; z-index: 1`);
                this.ctx = this.canvas.getContext("2d", { accelerated: true });
                // this.tempCanvas = document.createElement('canvas');
                // this.tempCtx = this.tempCanvas.getContext('2d');
                // this.tempCanvas.width = SCREEN_WIDTH;
                // this.tempCanvas.height = SCREEN_HEIGHT;
                const self = this;
                var browserZoomLevel = Math.round(window.devicePixelRatio * 100);


                const intervalAppend = setInterval(() => {
                    if (document.querySelector(".gameCont")) {
                        document.querySelector(".gameCont").appendChild(this.canvas);
                        if (Object.keys(this.snakes).length>1){
                            document.querySelector(".gameCont").appendChild(container_players);

                        }
                        
                        
                        this.setCanvasSize()

                        const heightCanvas = document.querySelector(".gameCont").offsetHeight + 95;
                        if (document.querySelector("#contBetsInf")) {
                            document.querySelector("#contBetsInf").style.top = `${heightCanvas}px`

                        }
                        clearInterval(intervalAppend)
                    }
                }, 30)

                this.playerSnake = { x: 0, y: 0 }


                this.foods = {}
                // this.initFoods(5000)

                this.miniSizeSnake = data.miniSizeSnake;
                this.screen = new Screen(this);
                this.bg = new BG(this);
                // if (window.matchMedia("(pointer:fine)").matches){
                this.getScreenRefreshRate();

                // this.findBot()
                // }





                // Все на canvas загрузились, можно продолжать
                // <div class="inforamtion">
                //     className class="close" onclick="cclassNameunction()onClick>
                //
                //     <div class="balance">
                //         classNameYour balance: <span>0$</span></h1>
                //
                // </div>
            }

            if (event === "change_timer") {

                document.querySelector(".time").innerHTML = this.formatTime(data.count)
            }
            if (event === "Table") {
                const first = data[0];
                const second = data[1];
                const third = data[2];
                let local_top = {}
                let answ = ``

                if (first) {

                    local_top[String(first.name)] = this.medalFirst;
                    if (this.typeString === "tournament") {
                        answ += `
                    <tr style="margin-bottom: 10px" class="gold">
                <td>1.${this.snakes[first.name].name} ${this.formatCurrency(this.snakes[first.name].cash)}</td>
                
    
            </tr>
            
                    `
                    }
                    else {


                        answ += `
                    <tr style="margin-bottom: 10px" class="gold">
                <td>1.${this.snakes[first.name].name}</td>
                
                
    
                    </tr>
            
                    `
                    }

                }
                if (second) {
                    local_top[String(second.name)] = this.medalSecond;
                    if (this.typeString === "tournament") {
                        answ += `
                    <tr class="serebro">
                <td>2.${this.snakes[second.name].name} ${this.formatCurrency(this.snakes[second.name].cash)}</td>
                
    
            </tr>
            
                    `
                    }
                    else {


                        answ += `
                        <tr class="serebro">
                <td>2.${this.snakes[second.name].name}</td>
                
    
            </tr>
                        `
                    }
                }
                if (third) {
                    local_top[String(third.name)] = this.medalThird;
                    if (this.typeString === "tournament") {
                        answ += `
                    <tr class="bronse">
                <td>3.${this.snakes[third.name].name} ${this.formatCurrency(this.snakes[third.name].cash)}</td>
                
    
            </tr>
            
                    `
                    } else {


                        answ += `
                        <tr class="bronse">
                <td>3.${this.snakes[third.name].name}</td>
                
                       </tr>
                        `


                    }

                }
                this.tableTop = local_top;
                document.querySelector("tbody").innerHTML = answ;

            }
            if (event === "change_online") {
                document.querySelector(".online_text").innerHTML = data.count
            }
            if (event === "NewPlayerConnect") {



                this.snakes[data.player.id] = new OtherPlayer(this, data.player.name, data.player.x, data.player.y, data.player.tailPositions, data.player.visiable, data.player.id, data.player.angle, data.player.speed, FAST_SPEED, data.player.cash, data.player.downCash, data.player.grownCount, data.player.downCount, data.player.width, data.player.skin, data.player.death, data.player.role)

            }
            if (event === "FoodNew") {
                // console.log(Object.keys(data).length)

                this.createFood(data);
            }
            if (event === "FoodNewPlayer") {
                if (Object.keys(data).length > 0) {
                    // console.log(Object.keys(data).length)
                    for (const [key, value] of Object.entries(data)) {

                        this.foods[key] = new Food(this, value.id, value.x, value.y, 10)
                    }
                }
            }
            if (event === "ChangeAngle") {
                this.snakes[data.id].angle = data.angle;
            }
            if (event === "Remove_player") {
                delete this.snakes[data.id]
            }
            if (event === "Shake") {
                this.shakeCamera(800, this.canvas);
            }
            if (event === "Death_player") {
                this.snakes[data.id].death = true;
            }
            if (event === "Death") {
                this.playerSnake.death = true;
                delete this.snakes[this.playerSnake.id]
                this.shakeCamera(1000, this.canvas);
                const self = this;
                setTimeout(() => {

                    if (data.winner) {
                        this.showWinnerModel(this.formatCurrency(data.salary), data.list_winers)
                    }
                    else {
                        if (this.typeString === "tournament") {
                            if (data.enemy) {

                                this.showFailModelTournament(data.enemy, this.formatCurrency(this.playerSnake.cash))

                            } else {
                                if (data.list_winers) {
                                    this.showWinners(data.list_winers)
                                }
                                else {


                                    this.showFailModelTournament("", -1)
                                }
                            }
                        }
                        else {


                            if (data.enemy) {

                                this.showFailModel(data.enemy, this.formatCurrency(this.playerSnake.cash))

                            } else {
                                this.showFailModel("", -1)
                            }
                        }
                    }
                }, 1000)
            }
            if (event === "see_mode") {
                this.playerSnake = new PlayerSnake(this, user, data.x, data.y, SNAKE_SPEED, FAST_SPEED, [], data.id, 0, 0, 0, 0, 20, "red", true, this.role)
                this.snakes[data.id] = this.playerSnake;
                this.screen.update()
                // console.log(data.x , data.y , this.playerSnake)
            }
            if (event === "removeFood") {

                delete this.foods[data.id]
                this.snakes[data.id_p].width = data.width;
                this.snakes[data.id_p].eye.EYE_DISTANCE = data.width / 2 + 5;
                this.snakes[data.id_p].cash = data.cash;
                if (data.id_p === this.playerSnake.id) {

                    document.querySelector(".balance h1").innerHTML = `${STRING_BALANCE}` + `<span>${this.formatCurrency(data.cash)}` + "</span>"

                }
            }
            if (event === "ChangeSpeed") {
                this.snakes[data.id].speed = data.speed;
            }
            if (event === "Disconnect_player") {
                delete this.snakes[data.id]
            }
            if (event === "close") {

                if (data.isOpen) {
                    if (this.typeString === "tournament") {
                        this.showFailModelTournament("", -1)
                    }
                    else {

                        this.showFailModel("", this.formatCurrency(this.playerSnake.cash))
                    }




                }
                else {
                    window.location.replace(this.link_redirect)


                }

            }
        })

    }
    fill_players(){
        if (document.querySelector(".count_players")){
            document.querySelector(".count_players").innerHTML=`Выживших:${Object.keys(this.snakes).length}`;

        }
    }
    findBot() {

        for (const [key, value] of Object.entries(this.snakes)) {
            this.id_follow_bot = key;
            break
        }
    }
    setCanvasSize() {
        const canvas = this.canvas;
        const ctx = this.ctx;
        SCREEN_WIDTH = 1327;
        SCREEN_HEIGHT = 700;


        // Вычисляем масштаб по ширине и высоте
        var scaleX = SCREEN_WIDTH / GAME_WIDTH;
        var scaleY = SCREEN_HEIGHT / GAME_HEIGHT;

        // Выбираем минимальный масштаб, чтобы сохранить пропорции
        var scale = Math.min(scaleX, scaleY);

        // Рассчитываем новые размеры canvas'а
        var newWidth = GAME_WIDTH * scale;
        var newHeight = GAME_HEIGHT * scale;

        // Устанавливаем новые размеры canvas'а
        canvas.width = this.store.isPhone ? document.documentElement.clientWidth + 200 : newWidth;
        canvas.height = newHeight;

        // Вычисляем смещение, чтобы центрировать canvas


        // Устанавливаем смещение canvas'а
        // canvas.style.left = 0 + 'px';
        // canvas.style.top = 100 + 'px';
        SCREEN_WIDTH = this.store.isPhone ? document.documentElement.clientWidth + 200 : newWidth;
        SCREEN_HEIGHT = newHeight;
        

    }
    preobr_last10(a) {
        let new_a = []
        for (let el of a) {
            let arr1 = el;
            let color = ""
            if (arr1[1] === "red") {
                color = "#960505"
            }
            if (arr1[1] === "blue") {
                color = "#043186"
            }
            if (arr1[1] === "gold") {
                color = "#bba90d"
            }
            if (arr1[1] === "green") {
                color = "#298604"
            }
            new_a.push([arr1[0], color])

        }
        return new_a;
    }
    preobr_topFive(a) {
        let new_a = []
        for (let el of a) {
            let arr1 = el[0].split(",")
            let color = ""
            if (arr1[1] === "red") {
                color = "#960505"
            }
            if (arr1[1] === "blue") {
                color = "#043186"
            }
            if (arr1[1] === "gold") {
                color = "#bba90d"
            }
            if (arr1[1] === "green") {
                color = "#298604"
            }
            let arr1_r = [arr1[0], color]

            new_a.push([arr1_r, el[1]])

        }
        return new_a
    }
    follow_ping_server() {
        setInterval(() => {
            this.startTimePing = Date.now()
            this.socket.send(this.pack({ event: "ping" }))
        }, 1000)
    }
    formatCurrency(amount) {
        const currency = 'RUB';

        const formatter = new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: currency,
        });

        let formattedAmount = formatter.format(amount);

        if (this.typeString !== "cost") {
            formattedAmount = formattedAmount.replace("₽", "B");
        }

        formattedAmount = formattedAmount.replace(",00", '');

        return formattedAmount;
    }
    showFailModel(enime, salary) {
        setTimeout(() => {
            if (this.role !== "admin") {
                window.location.replace(this.link_redirect)

            }
        }, 20 * 1000)
        if (this.playerSnake.role === "streamer") {
            const self = this
            document.querySelector(".eyes_block").innerHTML = `
                <img class="eyes" src="/assets/visible.png" alt="eyes">`
            document.querySelector(".eyes").addEventListener("click", () => {
                document.querySelector(".model").style.display = "none"
                document.querySelector(".login-box form").remove()
                document.querySelector(".eyes").remove()
                document.querySelector(".enter_block").innerHTML += `
    
                         <form action="" method="post">
                         <input type="hidden" name="method" value="see">
                                     <input type="hidden" name="room_id" value="${this.room}">
                                     <input type="hidden" name="cost_room" value="${this.cost}">
                                     <input type="hidden" name="type" value="${this.typeString}">
    
                         <button type="submit"><img class="eyes" src="/assets/enter.png" alt="enter"></button>
                         </form>
                    `
                self.handleImageClick()
            })
        }
        delete this.snakes[this.playerSnake.id]
        if (!this.showSuccses) {
            this.showFail = true;
            document.querySelector(".model").style.display = "flex";
            if (enime) {

                document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
    
    <div class="modelFail">
                <h1>Вы проиграли <span>${salary}</span></h1>
                                <h3>Вас убил: <span>${enime}</span></h3>
    
              <div class="buttons">
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
    
    
                })()'  class="submit">Сыграть еще раз</button>
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
    
    
                })()' class="closeBtn">Выйти</button>
              </div>
              </div>
            `
            } else {
                document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
    
    <div class="modelFail">
                <h1>Вы проиграли <span>${salary}</span></h1>
              <div class="buttons">
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
    
    
                })()'  class="submit">Сыграть еще раз</button>
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
    
    
                })()' class="closeBtn">Выйти</button>
              </div>
              </div>
            `
            }
        }
        if (this.role === "user") {
            setInterval(() => {
                window.location.replace(this.link_redirect)

            }, 15 * 1000)
        }
    }
    showWinners(winners) {
        setTimeout(() => {
            if (this.role !== "admin") {
                window.location.replace(this.link_redirect)

            }
        }, 20 * 1000)

        document.querySelector(".model").style.display = "flex";
        document.querySelector(".login-box").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
                
    <div class="modelFail"> <h1 style="text-align: center;margin-bottom: 20px">Победители турнира</h1>`
        for (let winner of winners) {
            document.querySelector(".login-box").innerHTML += `<h3 style="text-align: center;color: white">${winner.name} - <span style="color: greenyellow">${this.formatCurrency(winner.cashik)}</span></h3>`
        }
        document.querySelector(".login-box").innerHTML += `
            <div class="buttons">
                
                <button type="text" onclick='(function(){
                    window.location.replace("https://snake.money/enter_room_free")
    
    
                })()' class="closeBtn">Выйти</button>
              </div>
              </div>
            `

    }
    showFailModelTournament(enime, salary) {
        setTimeout(() => {
            if (this.role !== "admin") {
                window.location.replace(this.link_redirect)

            }
        }, 20 * 1000)
        if (this.playerSnake.role === "streamer") {
            const self = this
            document.querySelector(".eyes_block").innerHTML = `
                <img class="eyes" src="/assets/visible.png" alt="eyes">`
            document.querySelector(".eyes").addEventListener("click", () => {
                document.querySelector(".model").style.display = "none"
                document.querySelector(".login-box form").remove()
                document.querySelector(".eyes").remove()
                document.querySelector(".enter_block").innerHTML += `
    
                         <form action="" method="post">
                         <input type="hidden" name="method" value="see">
                                     <input type="hidden" name="room_id" value="${this.room}">
                                     <input type="hidden" name="cost_room" value="${this.cost}">
                                     <input type="hidden" name="type" value="${this.typeString}">
    
                         <button type="submit"><img class="eyes" src="/assets/enter.png" alt="enter"></button>
                         </form>
                    `
                self.handleImageClick()
            })
        }
        if (this.typeString === "tournament" && enime) {
            this.showFail = true;
            delete this.snakes[this.playerSnake.id]
            document.querySelector(".model").style.display = "flex";
            document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
                
    <div class="modelFail">
                <h1>Вы проиграли в турнире</span></h1>
                                <h3>Вас убил: <span>${enime}</span></h3>
    
              <div class="buttons">
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
    
    
                })()'  class="submit">Сыграть еще раз</button>
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
    
    
                })()' class="closeBtn">Выйти</button>
              </div>
              </div>
            `
        }
        else if ((!this.type && !this.showSuccses) || (salary === -1 && this.typeString === "tournament")) {
            this.showFail = true;
            delete this.snakes[this.playerSnake.id]
            document.querySelector(".model").style.display = "flex";
            if (salary === -1) {
                document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
                
    
    <div class="modelFail">
                <h1>Вы проиграли в турнире</h1>
              <div class="buttons">
              <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
    
    
                })()'  class="submit">Сыграть еще раз</button>
                <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
                    
    
                })()' class="closeBtn">Выйти</button>
              </div>
              </div>
            `
            }
        }


        else {
            window.location.replace(this.link_redirect)

        }
        if (this.role === "user") {
            setInterval(() => {
                window.location.replace(this.link_redirect)

            }, 15 * 1000)
        }
    }
    showWinnerModel(salary, winners) {
        setTimeout(() => {
            if (this.role !== "admin") {
                window.location.replace(this.link_redirect)

            }
        }, 20 * 1000)


        document.querySelector(".model").style.display = "flex"
        delete this.snakes[this.playerSnake.id]
        // document.querySelector(".model").style.animation = "errorAppear 1.5s ease-in-out";
        // document.querySelector(".model").style.animationFillMode = "forwards";

        document.querySelector(".login-box form").innerHTML = `
    <div class="modelSuccses">
        
                <h1>Вы выиграли в турнире <span>${salary}</span></h1><br/>
                <h1 style="text-align: center;margin-bottom: 20px">Победители турнира</h1>`
        for (let winner of winners) {
            document.querySelector(".login-box form").innerHTML += `<h3 style="text-align: center;color: white">${winner.name} - <span style="color: greenyellow">${this.formatCurrency(winner.cashik)}</span></h3>`
        }
        document.querySelector(".login-box form").innerHTML += `
                    <div class="buttons">
                     
                        
                    <button type="text" onclick='(function(){
                    window.location.replace(link_redirect)
    
                    
                })()' class="submit">Забрать приз</button> 
                </div>
                </div>
            `
        if (this.role === "user") {
            setInterval(() => {
                window.location.replace(this.link_redirect)

            }, 15 * 1000)
        }
    }
    updateTable(count_users) {

        if (this.online > 0) {
            document.querySelector(".leaders_table").style.opacity = 1;
        }
        else {
            // document.querySelector(".leaders_table").classList.toggle('hidden');
            document.querySelector(".leaders_table").style.opacity = 0;

        }
        const players = this.snakes;
        const sortedUsers = Object.entries(players)
            .filter(([key, value]) => !value.death)
            .sort((a, b) => b[1].cash - a[1].cash);

        let my_top;
        let local_top = {};

        for (let index = 0; index < sortedUsers.length; index++) {
            if (index === 0) {
                local_top[String(sortedUsers[index][1].id)] = this.medalFirst;

            }
            if (index === 1) {
                local_top[String(sortedUsers[index][1].id)] = this.medalSecond;

            }
            if (index === 2) {
                local_top[String(sortedUsers[index][1].id)] = this.medalThird;

            }
            if (sortedUsers[index][1].name === this.playerSnake.name) {
                sortedUsers[index].push("hightlite")
                my_top = index + 1;
                break;
            }
        }

        this.tableTop = local_top;

        const topUsers = sortedUsers.slice(0, count_users);
        if (my_top > count_users) {
            topUsers.push([my_top, this.playerSnake, "hightlite"])

        }

        this.setTableUsers(topUsers);
        // let answ = ``;
        //
        // for(let index = 0;index < topUsers.length;index++){
        //     const user = topUsers[index][1]
        //     answ+=`<div class="player"><div class="nickname">${index+1}. <span>${user.name}</span></div> <div class=${"score "+(this.typeString!=="cost"?"score_b":"score_r")}><span>${this.formatCurrency(user.cash)}</span></div></div>`
        // }
        // if (this.snakes[this.playerSnake.id]) {
        //
        //
        //     answ += `<div class="player"><div class="nickname">${my_top}. <span>${this.playerSnake.name}</span></div> <div class=${"score " + (this.typeString !== "cost" ? "score_b" : "score_r")}><span>${this.formatCurrency(this.playerSnake.cash)}</span></div></div>`
        // }
        // document.querySelector(".leaders_table").innerHTML=answ;

    }
    updateOnline() {

        const count = Object.keys(this.snakes).filter(el => !this.snakes[el].death).length
        this.online = count
        this.setOnline(count);


    }
    handleImageClick() {
        this.socket.send(this.pack({ event: "see_mode", data: {} }));
    }
    showSuccsesModel(salary) {
        setTimeout(() => {
            if (this.role !== "admin") {
                window.location.replace(this.link_redirect)

            }
        }, 20 * 1000)

        if (this.playerSnake.role === "streamer") {
            const self = this
            document.querySelector(".eyes_block").innerHTML = `
                <img class="eyes" src="/assets/visible.png" alt="eyes">`
            document.querySelector(".eyes").addEventListener("click", () => {
                document.querySelector(".model").style.display = "none"
                document.querySelector(".login-box form").remove()
                document.querySelector(".eyes").remove()
                document.querySelector(".enter_block").innerHTML += `
    
                         <form action="" method="post">
                         <input type="hidden" name="method" value="see">
                                     <input type="hidden" name="room_id" value="${this.room}">
                                     <input type="hidden" name="cost_room" value="${this.cost}">
                                     <input type="hidden" name="type" value="${this.typeString}">
    
                         <button type="submit"><img class="eyes" src="/assets/enter.png" alt="enter"></button>
                         </form>
                    `
                self.handleImageClick()
            })
        }
        if (!this.type && !this.showFail) {
            this.showSuccses = true;

            delete this.snakes[this.playerSnake.id]
            // document.querySelector(".model").style.animation = "errorAppear 1.5s ease-in-out";
            // document.querySelector(".model").style.animationFillMode = "forwards";
            if (this.typeString === "free") {


                document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
    
    <div class="modelSuccses">
        
                <h1>Вы могли заработать <span>${salary}</span></h1><br/>
                <h4 style="font-size: 20px">Коммисия 1.8%</h4>
                    <div class="buttons">
                        <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
                    
    
                })()'  class="submit">Сыграть еще раз</button>
                        
                    <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
    
                    
                })()' class="closeBtn">Выйти</button>
                </div>
                </div>
            `
            }
            else {
                document.querySelector(".login-box form").innerHTML = `
    <input type="hidden" class="modelAns" name="result" value="">
                <input type="hidden" name="room_id" value="${this.room}">
                <input type="hidden" name="cost_room" value="${this.cost}">
                <input type="hidden" name="type" value="${this.typeString}">
    
    <div class="modelSuccses">
        
                <h1>Вы заработали <span>${salary}</span></h1><br/>
                <h4 style="font-size: 20px">Коммисия 1.8%</h4>
                    <div class="buttons">
                        <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="reload";
                    
    
                })()'  class="submit">Сыграть еще раз</button>
                        
                    <button type="text" onclick='(function(){
                    document.querySelector(".modelAns").value="exit";
    
                    
                })()' class="closeBtn">Выйти</button>
                </div>
                </div>
            `
            }
        }
        else {
            window.location.replace(this.link_redirect)

        }
        if (this.role === "user") {
            setInterval(() => {
                window.location.replace(this.link_redirect)

            }, 15 * 1000)
        }

    }
    getScreenRefreshRate() {
        let frameCount = 0;
        let startTime = performance.now();
        const self = this;
        function countFrames() {
            frameCount++;
            if (performance.now() - startTime >= 1000) {
                const refreshRate = frameCount;
                self.socket.send(self.pack({ event: "gerc", data: { gerc: refreshRate } }))


            } else {
                requestAnimationFrame(countFrames);
            }
        }

        countFrames();

    }


    isConsoleOpen() {
        var startTime = new Date();
        debugger;
        var endTime = new Date();

        return endTime - startTime > 100;
    }
    animate() {
        requestAnimationFrame(this.animate);
        this.draw(); // Предполагается, что this.draw() является вашей функцией отрисовки
    }
    updateFps() {
        const currentFrameTime = performance.now();
        const deltaTime = currentFrameTime - this.lastFrameTime;
        this.lastFrameTime = currentFrameTime;

        this.framesThisSecond++;
        if (currentFrameTime > 1000) {
            this.fps = this.framesThisSecond;
            this.framesThisSecond = 0;
        }

        // Отображаем значение FPS на холсте
        this.ctx.fillStyle = "black";
        this.ctx.font = "16px Arial";
        this.ctx.fillText("FPS: " + this.fps, 10, 20);

        // Запускаем следующий кадр
        requestAnimationFrame(() => this.updateFps());
    }

    start() {
        // Запускаем первый кадр
        requestAnimationFrame(() => this.updateFps());
    }
    shakeCamera(duration, canvas) {
        var startTime = performance.now();
        var shakeAmount = 15; // Максимальное смещение при дрожании

        function updatePosition() {
            var currentTime = performance.now();
            var progress = currentTime - startTime;

            if (progress < duration) {
                var offsetX = (Math.random() - 0.5) * shakeAmount;
                var offsetY = (Math.random() - 0.5) * shakeAmount;

                canvas.style.transform = "translate(" + offsetX + "px, " + offsetY + "px)";

                requestAnimationFrame(updatePosition);
            } else {
                canvas.style.transform = ""; // Сбрасываем смещение

            }
        }

        updatePosition();
    }
    pack(data) {
        return msgpack.encode(data)

    }

    unpack(data) {
        return msgpack.decode(new Uint8Array(data))
    }
    getCurrentTime() {
        var date = new Date(); // Получаем текущую дату и время
        var hours = this.addLeadingZero(date.getHours()); // Получаем текущий час (от 0 до 23)
        var minutes = this.addLeadingZero(date.getMinutes()); // Получаем текущие минуты (от 0 до 59)
        var seconds = this.addLeadingZero(date.getSeconds()); // Получаем текущие секунды (от 0 до 59)
        var milliseconds = this.addLeadingZeros(date.getMilliseconds(), 3); // Получаем текущие миллисекунды (от 0 до 999)

        var currentTime = hours + ':' + minutes + ':' + seconds + '.' + milliseconds;
        return currentTime;
    }

    addLeadingZero(number) {
        return (number < 10 ? '0' : '') + number; // Добавляем ведущий ноль, если число меньше 10
    }

    addLeadingZeros(number, length) {
        var zeros = '';
        for (var i = 0; i < length; i++) {
            zeros += '0';
        }
        return (zeros + number).slice(-length); // Добавляем ведущие нули, если число меньше заданной длины
    }
    createFood(data) {
        if (Object.keys(data).length > 0) {


            for (const [key, value] of Object.entries(data)) {

                this.foods[key] = new Food(this, value.id, value.x, value.y, 10);
            }
        }
    }
    startGame() {
        this.animationFrameId = requestAnimationFrame(() => this.draw());
    }

    frameCount(timeStart) {

        let now = performance.now();
        let duration = now - timeStart;

        if (duration < 100) {

            this.counter++;

        } else {

            this.fps = this.counter * 10;
            this.counter = 0;
            timeStart = now;

        }
        requestAnimationFrame(() => this.frameCount(timeStart));
    }


    createOtherSnakes(data) {


        for (const [key, value] of Object.entries(data)) {
            this.snakes[key] = new OtherPlayer(this, value.name, value.x, value.y, value.tailPositions, value.visiable, value.id, value.angle, value.speed, FAST_SPEED, value.cash, value.downCash, value.grownCount, value.downCount, value.width, value.skin, value.death, value.role)


        }
    }
    getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
    }

    /*loop(){
        this.update();
        this.draw();
        setTimeout(()=>{
            this.loop();
        } , 20)
    }*/


    clearScreen() {
        this.ctx.clearRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);
    }
    drawOtherPlayer(id) {
        this.snakes[id].draw();
    }
    draw() {
        if (this.ctx) {





            const miniContext = this.ctx;
            const widthMap = 200;
            const heightMap = 200
            const startPositionX = SCREEN_WIDTH - 200;
            const startPositionY = SCREEN_HEIGHT - 200;
            const size = 3;
            const scaleX = widthMap / GAME_WIDTH;
            const scaleY = heightMap / GAME_HEIGHT;

            this.ctx.fillStyle = "red";
            this.screen.update()

            // this.ctx.fillRect(10, 10, 100, 100);
            this.clearScreen();
            this.bg.draw();
            for (const [key, value] of Object.entries(this.foods)) {
                value.draw();
            }

            const lastFillStyle = miniContext.fillStyle;
            const laststrokeStyle = miniContext.strokeStyle
            const lastLineWidth = miniContext.lineWidth
            // this.playerSnake.draw();

            // miniContext.strokeRect(startPositionX, startPositionY, widthMap, heightMap);'
            for (const [key, value] of Object.entries(this.snakes)) {

                value.draw();



            }


            if (this.isDrawNumber) {
                this.ctx.font = '300px Arial';
                this.ctx.textAlign = 'center';
                this.ctx.textBaseline = 'middle';
                this.ctx.fillStyle = "#fff"
                this.ctx.fillText(String(this.numberEnd), this.canvas.width / 2, this.canvas.height / 2);

            }


        }
        this.idFrameDraw = window.requestAnimationFrame(this.draw);

    }


}
export default Game